import { render } from "./PartAssignment.vue?vue&type=template&id=d0a814cc&scoped=true"
import script from "./PartAssignment.vue?vue&type=script&lang=js"
export * from "./PartAssignment.vue?vue&type=script&lang=js"

import "./PartAssignment.vue?vue&type=style&index=0&id=d0a814cc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0a814cc"]])

export default __exports__